import { FlexBox } from '@dixa/lib-shared-habla';

import { ConversationsTablePreviewButton } from './components/previewButton/conversationsTablePreviewButton';
import { ConversationsTableRowMenu } from './components/rowMenu/conversationsTableRowMenu';

/** Represents the content of the actions cell in the conversations table. */
export const ConversationsTableActions = (): JSX.Element => {
  return (
    <FlexBox alignItems="center" gap="100" justifyContent="flex-end">
      <ConversationsTablePreviewButton />
      <ConversationsTableRowMenu />
    </FlexBox>
  );
};
